module.exports = __webpack_public_path__ + "media/images/front/noimage-9fc2128fb1cf1f76a44f4ab2ef8daaf4.png";